import type { IFilter } from '@chax-at/prisma-filter-common';
import type { IUserFeedbackFilter } from 'common/interface/filter.interface';

export const userFeedbackKeys = {
  all: ['userFeedback'],
  lists: () => [...userFeedbackKeys.all, 'list'],
  list: (filter?: IFilter<IUserFeedbackFilter>, search?: string) => [...userFeedbackKeys.lists(), { filter, search }],
  details: () => [...userFeedbackKeys.all, 'detail'],
  detail: (id: number) => [...userFeedbackKeys.details(), id],
  shouldUserSeePrompt: (userId: number) => [...userFeedbackKeys.all, 'shouldSeePrompt', userId],
};
